import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=88a5e0da&scoped=true&"
var script = {}
import style0 from "./Contato.vue?vue&type=style&index=0&id=88a5e0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a5e0da",
  null
  
)

export default component.exports